<template>
    <select v-model="currentValue" :disabled="disabled || readonly">
        <option v-if="options"
                v-for="option in options"
                :value="option.value"
                :data-icon="option.icon ? option.icon : ''"
                :disabled="(option.disabled ? option.disabled : false)"
        >{{option.text}}</option>
    </select>
</template>

<style lang="scss" scoped>

</style>

<script>
    export default {

        // Intentionally left type agnostic
        props: ['value', 'options', 'search', 'disabled', 'readonly'],

        data() {
            return {
                currentValue: null,
                selectPicker: null,
            };
        },

        watch: {

            value(newVal) {
                $(this.$el).selectpicker('val', newVal);
            },

            currentValue(newVal) {
                this.$emit('input', newVal);
                this.$emit('change', newVal);
            },

            options() {
                this.$nextTick(() => {
                    $(this.$el).val(this.value);
                    $(this.$el).selectpicker('refresh');
                    $(this.$el).selectpicker('val', this.value);
                });
            },

        },

        created() {
            this.currentValue = this.value;
            this.displaySearch = (this.search === true ? true : false);
        },

        mounted() {
            $(this.$el).selectpicker({
                liveSearch: (this.search === true),
            });

        },

    }
</script>

